import fpApiUtil from "./fp-api-util";

const GRP_BASE = "factoryplan/master/fpconfig-grp";
const DTL_BASE = "factoryplan/master/fpconfig-codes";
const SAVE_URL = "common/setting/fpconfig-save";
const DELETE_URL = "common/setting/fpconfig-delete";

const getGroups = (params) => fpApiUtil.postParams(GRP_BASE, params);
const getDetails = (params) => fpApiUtil.postParams(DTL_BASE, params);
// SettingController#saveFpConfigSettings/deleteFpConfigSettings — 표준 changes 단일 필드가 아니라
// settingChanges(CmSetting)/comnCodeChanges(CmComnCode) 두 테이블분 변경분을 별도 필드로 받는다.
const save = (settingChanges, comnCodeChanges) => fpApiUtil.postFields(SAVE_URL, { settingChanges, comnCodeChanges });
const remove = (settingChanges, comnCodeChanges) => fpApiUtil.postFields(DELETE_URL, { settingChanges, comnCodeChanges });

const fpConfigurationService = { getGroups, getDetails, save, remove };
export default fpConfigurationService;
